import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import {MatMenuModule} from '@angular/material/menu';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import moment from 'moment';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { OvenDashboardComponent } from '../oven-dashboard/oven-dashboard.component';
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { ThresholdDialBoxComponent } from '../threshold-dial-box/threshold-dial-box.component';
import { T } from '@angular/cdk/keycodes';
@Component({
  selector: 'app-oven-device-list',
  templateUrl: './oven-device-list.component.html',
  styleUrls: ['./oven-device-list.component.scss'],
  standalone: true,
  imports: [CommonModule, MatToolbar,MatMenuModule, MatIcon, MatButtonModule]
})
export class OvenDeviceListComponent implements OnInit {

   @Input() tabName:any="";
     @Input() tab1:any="";
     @Input() tab2:any="";
     @Input() tab3:any="";
     @Input() tab4:any="";
     public breadcrumbsArray: any = [
       {
         page_ref: 'clients',
         page_title: 'clients'
       }
     ];
     public company_name: string;
     public showList: boolean = true;
     public emptyMsg: boolean = false;
     public today: Date;
     public eBoilerRoomApi: any = BaseUrlConstantsService.eBoilerRoomApi;
     private allSitesUrl = BaseUrlConstantsService.GET_SITES;
     private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
     private ovenBaseApi : any = BaseUrlConstantsService.OVEN_BASE_URL;
     public eBoilerRoomListData: any=[];
     public clientId: any;
     public boilerName: string = "";
     public sitesList: any = [];
     public shouldShow: boolean;
     public hideItemsFromAssets: boolean = false;
     public allDeviceBoilerArray: any = [];
     public groupList: any[];
     public siteFilterValue: any =[];
     public userRoll: string;
     groupFilterValue: any[];
     public selectedSiteId: any;
     public subsystemId: any;
     public deviceId: any;
     constructor(
       public router: Router,
       public service: BackendApiService,
       public activeRoute: ActivatedRoute,
     ) {
       this.utcTime();
       this.company_name = localStorage.getItem('company_name');
       if (localStorage.getItem('role') === 'ADMIN') {
         this.clientId = localStorage.getItem('admin_client_id');
       }else{
         this.clientId = localStorage.getItem('user_id');
       }
       this.userRoll = localStorage.getItem("role");
       if (this.userRoll === "USER") {
         this.company_name = localStorage.getItem("user_name");
         localStorage.setItem("company_name", this.company_name);
         this.hideItemsFromAssets = false;
       } else {
         this.hideItemsFromAssets = true;
       }
   
       activeRoute.queryParams.subscribe((params) => {
         console.log(params,'paramssssss11');
          this.geteAllOvenData();  

         this.tabName=params["tabName"];
         this.tab1 = params['tab1']
         this.tab2 = params['tab2']
         this.tab3 = params['tab3']
         this.tab4 = params['tab4']
       })
       console.log('ener');
      }
   
     utcTime() {
       setInterval(() => {
         this.today = new ConvertDatetimePipe().convertDateTime(new Date());
       }, 1000);
     }
   
     ngOnInit(): void {
       if (this.userRoll === "USER") {
         // this.clientId = localStorage.getItem("user_id");
         this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
       } else {
         this.clientId = localStorage.getItem("admin_client_id") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("admin_client_id");
       }
       this.geteAllOvenData();
       this.getallSitesAndGroupsInfo(this.clientId);
       console.log('eeneneen')
     }
     goToPageLink(name: string) {
       this.router.navigate([name]);
     }
     getallSitesAndGroupsInfo(id) {
       this.service.getData(this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + id + Math.floor(Math.random() * 9000 + 1000)).then((res) => {
         if (JSON.parse(JSON.stringify(res)).data.status === "success") {
           this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
           if (this.sitesList.length !== 0) {
             this.emptyMsg = false;
           } else {
             this.emptyMsg = true;
           }
         } else {
           this.emptyMsg = true;
           this.service.showError("Something went wrong.");
         }
       });
     }
     async getGroupsBySiteId(siteId: any) {
       let body;
       if (this.userRoll === "USER") {
         body = {
           client_id: localStorage.getItem("client_id"),
           user_id: localStorage.getItem("user_id"),
           site_id: siteId,
         };
       } else {
         body = {
           client_id: localStorage.getItem("user_id"),
           site_id: siteId,
         };
       }
       this.service
         .getData(
           this.getApplicationsUrl +
           "/" +
           this.clientId +
           "/" +
           siteId
         )
         .then((res) => {
           if (JSON.parse(JSON.stringify(res)).data.status === "success") {
             this.groupList = JSON.parse(JSON.stringify(res)).data.body;
             if (this.groupList.length !== 0) {
               this.emptyMsg = false;
             } else {
               this.emptyMsg = true;
             }
           } else {
             this.service.showError("Something went wrong.");
           }
         });
     }
     //this function call site change
     onSiteSelected(id) {
       this.selectedSiteId = id;
       if(id == 0){
         localStorage.setItem("_siteId", null);
         this.siteFilterValue = [];
         //this.groupFilterValue = [];
         this.eBoilerRoomListData = this.allDeviceBoilerArray;
         if(this.eBoilerRoomListData.length != 0){
           this.emptyMsg = false;
         }else{
           this.emptyMsg = true;
         }
         this.groupList = [];
       }else{
         localStorage.setItem("_filterVal", null);
         localStorage.setItem("_searchVal", null);
         localStorage.setItem("_siteId", id);
         this.eBoilerRoomListData = this.allDeviceBoilerArray;
         this.groupList = []
         this.siteFilterValue = this.eBoilerRoomListData.filter(
                 (result) => result.site_id === parseInt(id)
         );
         this.eBoilerRoomListData = this.siteFilterValue;
         if(this.eBoilerRoomListData.length === 0){
           this.emptyMsg = true;
         }else{
           this.emptyMsg = false;
         }
         this.getGroupsBySiteId(id);
       }
     }
   
     //on application click
   
     onGroupSelected(id) {
       localStorage.setItem("_searchVal", null);
       localStorage.setItem("_filterVal", null);
       localStorage.setItem("_groupId", id);
       if (parseInt(id) === 0) {
         localStorage.setItem("_siteId", null);
         this.groupFilterValue = [];
         this.eBoilerRoomListData = this.allDeviceBoilerArray;
         if (this.siteFilterValue.length != 0) {
           for (let i = 0; i < this.siteFilterValue.length; i++) {
             this.siteFilterValue = this.eBoilerRoomListData.filter(
               (result) =>
                 result.site_id === parseInt(this.siteFilterValue[i].site_id)
             );
           }
           this.eBoilerRoomListData = this.siteFilterValue;
           if (this.eBoilerRoomListData.length === 0) {
             this.emptyMsg = true;
           } else {
             this.emptyMsg = false;
           }
         } else {
           this.eBoilerRoomListData = this.allDeviceBoilerArray;
           this.siteFilterValue = this.eBoilerRoomListData.filter(
             (result) => result.site_id === this.selectedSiteId
           )
           this.eBoilerRoomListData = this.siteFilterValue
           if (this.eBoilerRoomListData.length === 0) {
             this.emptyMsg = true;
           } else {
             this.emptyMsg = false;
           }
         }
       }
       else {
         // clearTimeout(this._timeOut);
         this.eBoilerRoomListData = this.allDeviceBoilerArray;
         this.groupFilterValue = this.eBoilerRoomListData.filter(
           (result) => result.application_id === parseInt(id)
         );
         this.eBoilerRoomListData = this.groupFilterValue;
         
         if (this.eBoilerRoomListData.length === 0) {
           this.emptyMsg = true;
         } else {
           this.emptyMsg = false;
   
         }
       }
     }
   
     geteAllOvenData(){
       this.service.getData(`${this.ovenBaseApi}api/v1/oven-assets/getAll/custom-oven/${this.clientId}`)
         .then((response:any) => {
           this.eBoilerRoomListData=[];
           if(response.status === 'success'){
             if(response.data.length != 0){
               this.emptyMsg = false;
              this.eBoilerRoomListData = response.data;
              //  this.allDeviceBoilerArray = response.data;;
             }else{
               this.emptyMsg = true;
             }
           }else{
             this.emptyMsg = true;
           }
         })
     }
     openOvenDashboard(id, name, oven_id){
       localStorage.setItem('subsystem_id', id);
       localStorage.setItem('subsystem_name', name);
       localStorage.setItem('oven_id', oven_id);
       const navigationExtras = {
         skipLocationChange: true,
         queryParams: {
           tabName:this.tabName,
           tab1:this.tab1,
           tab2:this.tab2,
           tab3:this.tab3,
           tab4:this.tab4,
           roomId: id,
           subsystem_name: name,
           pageRef: "ovenDashobard",
         },
       };
       this.router.navigate(['/oven-dashboard'],navigationExtras);
     }
     editConfigurator(subsystem_id, name, site_name, application_name){
       const navigationExtras = {
         skipLocationChange: true,
         queryParams:{
           subsystem_id:subsystem_id, 
           boilerName: name, 
           site_name: site_name, 
           application_name:application_name,
           tabName:this.tabName,
           tab1:this.tab1,
           tab2:this.tab2,
           tab3:this.tab3,
           tab4:this.tab4,}
       };
       this.router.navigate(['boiler-configurator'],navigationExtras);
     }
   
     deleteOvenFun(subsystem_id, gateway_address, device_id){
      this.deviceId = device_id; 
      this.subsystemId = subsystem_id;
      console.log(subsystem_id, gateway_address,'address')
       this.service.deleteInfo(`${this.ovenBaseApi}api/v1/oven-assets/delete/${this.deviceId}/${this.subsystemId}`)
       .then((response:any) =>{
         if(response.status === 'success'){
           if(response.message === 'Oven Asset Deleted Successfully'){
             this.service.showSuccess(response.message);
             this.geteAllOvenData();
             
           }else{
             this.service.showError('Something went wrong!');
           }
         }else{
           this.service.showError('Something went wrong!');
         }
       })
     }
}
